import styled from 'styled-components';
import colors from 'themes/Main';

const {
  white,
  gray02,
  gray03,
  gray01,
  darkBlue,
  gray06,
  danger,
  success,
  warning,
} = colors;

export const BlockHeaderDiv = styled.div`
  &.actions-box > div {
    display: none;
    position: absolute;
    top: 5px;
    right: 10px;
  }

  &.actions-box:hover div {
    display: block;
  }

  ${({ isFull }) => `
    min-width: calc((100% - 214px) / 3);
    width: ${isFull ? 'auto' : '100%'};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: ${isFull ? 'center' : 'flex-end'};
    position: relative;

    > div {
      top: 2px;
      right: 10px;
    }
  `}
`;

export const QuestionControllersWrap = styled.div`
  width: ${({ isFull }) =>
    isFull
      ? 'calc((100% - 214px)) !important'
      : 'min(100% - 214px, 50%) !important'};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ isFull }) => (isFull ? 'space-between' : 'flex-end')};

  > div {
    width: ${props => `calc(100% / ${props.children.length})`};
    padding: 0 8px;

    label {
      text-align: left;
    }

    &:nth-child(2),
    &:nth-child(3) {
      width: 30%;
    }

    > button {
      margin: 0 8px;
    }
  }

  &.isAdmin > div {
    width: 100%;
    text-align: right;
  }
`;

export const MoreActionsTable = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 4px 12px;
  flex-wrap: wrap;
`;

export const MoreActionsTableHeader = styled.div`
  width: fill-available;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  padding: 4px 0;
  border-bottom: 1px solid ${gray06};

  div {
    color: ${gray01} !important;
    font-weight: 700;
    width: 90px;
    text-align: center;

    &:first-of-type {
      width: 120px;
      text-align: left;
    }
  }
`;

export const MoreActionsInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 4px 0;
  width: fill-available;
`;

export const InfoStrong = styled.strong`
  color: ${darkBlue};
  font-weight: 700;
  width: 120px;
`;

export const InfoSpan = styled.span`
  color: ${gray01};
  font-weight: 400 !important;
  width: 90px;
  text-align: center;
`;

const levelColor = l => {
  const num = parseFloat(l * 100).toFixed(0);
  switch (true) {
    case num >= 100:
      return danger;
    case num >= 50 && num < 100:
      return warning;
    default:
      return success;
  }
};

export const Importance = styled.span`
  ${({ level }) => `

    font-size: 12px;
    font-weight: 700;
    color: ${levelColor(level)}
  `}
`;

export const AreaButtonsWrap = styled.div`
  width: 100%;
  display: flex;
  padding: 12px 4px;
  flex-direction: row;
  align-items: center;
  background: #f8f9fa;
  justify-content: space-between;
`;

export const AreaActions = styled.div`
  &:hover div {
    display: block;
  }

  > div {
    display: none;
    position: absolute;
    top: 15px;
    right: 60px;
    flex-direction: column;
  }
`;

export const FunctionSelectContainer = styled.div`
  margin-bottom: 32px;

  > div {
    width: 40%;
  }
`;

export const SmallText = styled.small`
  color: ${gray03};
  display: block;
  font-size: 12px;
`;

export const SubmitContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding-bottom: 80px;
`;

export const CommentBox = styled.div`
  cursor: default;
  background-color: ${white};
  margin-bottom: 16px;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0px 1px 10px rgba(219, 219, 219, 0.2),
    0px 4px 5px rgba(219, 219, 219, 0.12), 0px 2px 4px rgba(219, 219, 219, 0.14);
  position: relative;

  p {
    color: ${gray02};
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
